import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { STATICPAGE_HEADER_COLOR_CLASSES } from "npmlinks-constants";

import { getRandomNumberWithRange } from "../../utils";
import StaticPageTitle from "../../component/StaticPageTitle";
import WhoWeAreLeftNav from "./WhoWeAreLeftNav";
import StaticPageContent from "../../component/StaticPageContent";
import WhoWeAreRightContent from "./WhoWeAreRightContent";

@inject("CommonStore")
@observer
class WhoWeAre extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;
    const headerColorDecider =
      (isDesktop &&
        STATICPAGE_HEADER_COLOR_CLASSES[getRandomNumberWithRange()]) ||
      "nw-whoweare-color";
    if (global && global.isServer) {
      return null;
    }
    return (
      <GridContainer>
        <GridRow>
          <GridColumn>
            <StaticPageTitle.component
              title="Who we are"
              className={headerColorDecider}
            />
          </GridColumn>
        </GridRow>
        <GridRow className="nwc-main-content-wrapper">
          <GridColumn className="nwc-grid-col-sm-3">
            <WhoWeAreLeftNav.component />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-7 nw-staticpage-contentdescription">
            <StaticPageContent.component fetchDescription="whoweare" className="nw-staticpage-contentdescription" />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-2 nw-whoweare-rightsidecontent">
            <WhoWeAreRightContent.component />
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

export { default as WhoWeAreLeftNav } from "./WhoWeAreLeftNav";
export { default as WhoWeAreRightContent } from "./WhoWeAreRightContent";

WhoWeAre.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: WhoWeAre.wrappedComponent,
  component: WhoWeAre,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/WhoWeAre/index.js